import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { DetailRequestSI, DetailResponseSI } from '@views/interfaces/services/detail.interface';

@Injectable({
  providedIn: 'root',
})
export class DetailService {
  constructor(private _http: HttpClient) {}

  async getDetail(idProject: string): Promise<DetailResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<DetailResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.DETAIL}/${idProject}`)
    );
    return result.payload;
  }
  
  async saveDetail(body: DetailRequestSI): Promise<void> {
    const result = await firstValueFrom<ResponseCommonSI<void>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.DETAIL}`, body)
    );
    return result.payload;
  }
}
